exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-form-group{margin:0}input[type=color].form-control{height:36px;padding:0!important;border:none;border-radius:20px;overflow:hidden}input[type=checkbox]{margin:0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f564366","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/core/components/mdFormGroupInput/index.vue
// module id = 1020
// module chunks = 0